module.exports = __webpack_public_path__ + "media/images/delete-92817353774878df7ebe47c6998762c5.svg";